import Component from './applicant_advance_filter.vue'
export default Component
